import React from 'react';
import './Stats.css';

const stats = [
  { value: '7+', label: 'Herbal Products' },
  { value: '50+', label: 'Countries Served' },
  { value: '10+', label: 'Years of Experience' },
  { value: '8', label: 'Certifications' },
];

const Stats: React.FC = () => {
  return (
    <div className="stats-bar">
      {stats.map((stat) => (
        <div className="stat-item" key={stat.label}>
          <span className="stat-value">{stat.value}</span>
          <span className="stat-label">{stat.label}</span>
        </div>
      ))}
    </div>
  );
};

export default Stats;
